<div class="modal-header bg-dark text-white">
  <h4 class="modal-title">
    <ng-icon name="lucideMail" class="me-2"></ng-icon>
    Send Award Notification
  </h4>
  <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <!-- Supplier Information -->
  <div class="alert alert-light border mb-4">
    <div class="d-flex align-items-center">
      <ng-icon name="lucideBuilding2" class="me-2"></ng-icon>
      <div>
        Recipient: <strong>{{ supplierGroup?.supplier?.name }}<span *ngIf="supplierGroup?.supplier?.supplier_alias"> ({{ supplierGroup.supplier.supplier_alias }})</span></strong>
      </div>
    </div>
  </div>

  <!-- Email Subject -->
  <div class="mb-4">
    <label for="emailSubject" class="form-label">
      <ng-icon name="lucideMail" class="me-1"></ng-icon>
      Email Subject
    </label>
    <input
      id="emailSubject"
      type="text"
      class="form-control"
      [value]="getEmailSubject()"
      disabled
      readonly>
    <div class="form-text">
      The email subject is automatically generated and cannot be modified.
    </div>
  </div>



  <!-- Email Preview -->
  <div class="mb-4">
    <label class="form-label">
      <ng-icon name="lucideEye" class="me-1"></ng-icon>
      Email Preview
    </label>
    <div class="border rounded p-3 bg-light">
      <div *ngIf="previewLoading" class="text-center text-muted py-3">
        <span class="spinner-border spinner-border-sm me-2" role="status"></span>
        Loading preview...
      </div>
      <div *ngIf="!previewLoading && previewError" class="text-danger small">
        {{ previewError }}
      </div>
      <!-- The airline's own template, rendered by the server: a fully sandboxed frame,
           never the page's DOM (no script, no forms, no navigation). -->
      <iframe *ngIf="!previewLoading && !previewError"
              title="Email preview" sandbox=""
              [attr.srcdoc]="safeEmailPreview"
              style="width: 100%; height: 400px; border: 0; background: #fff;"></iframe>
    </div>
    <div class="form-text">
      This preview reflects your airline's email template. Managers can edit the template in
      <strong>Settings &rarr; Email Templates</strong>.
    </div>
  </div>

  <!-- Warning for Mixed Awards -->
  <div *ngIf="hasMixedAwards()" class="alert alert-warning">
    <ng-icon name="lucideTriangle" class="me-2"></ng-icon>
    <strong>Mixed Award Status:</strong> This notification includes both tentatively awarded and fully awarded locations.
    The supplier will be informed about the different award statuses.
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="cancel()" [disabled]="loading">
    <ng-icon name="lucideX" class="me-1"></ng-icon>
    Cancel
  </button>
  <button type="button" class="btn btn-dark" (click)="sendEmail()" [disabled]="loading">
    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
    <ng-icon *ngIf="!loading" name="lucideSend" class="me-1"></ng-icon>
    {{ loading ? 'Sending...' : 'Send Notification' }}
  </button>
</div>
